import { LottieAnimations } from 'src/assets'

const { mobile, web, uiux, project } = LottieAnimations.Capabilities

const Capabilities = {
  mobile: {
    title: 'Mobile App Development',
    description:
      'Expertise in React Native and Flutter for building cross-platform applications that offer seamless user experience',
    media: mobile,
  },
  web: {
    title: 'Web Development',
    description: 'Proficient in web development using React and Angular, building dynamic and responsive web apps',
    media: web,
  },
  design: {
    title: 'UI/UX Design',
    description:
      'Creative UI/UX designer specializing in building elegant and intuitive interfaces for web and mobile apps',
    media: uiux,
  },
  project: {
    title: 'Project Management',
    description:
      'Good Experience in managing software project & delivering high-quality products through the development life cycle',
    media: project,
  },
}

export { Capabilities }
